import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/front/10_cartoonish-5/10_cartoonish-5"
 * Contains 6 texture(s)
 */
export class CardsFront10Cartoonish5Atlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/front/10_cartoonish-5/10_cartoonish-5';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '6-diamonds.png',
        '6-clubs.png',
        '5-spades.png',
        '5-hearts.png',
        '5-diamonds.png',
        '5-clubs.png'
    ] as const;
}
